export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_plot.1de38d4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};